import { Button, Modal, Typography } from "antd";
import AppSelect from "../../common/FormInputs/AppSelect";
const { Title } = Typography;

const AuditType = ({
  open,
  handleCancel,
  handleBack,
  auditType,
  setAuditType,
  auditTypeOptions,
}) => {
  const handleChange = (value) => {
    setAuditType(value);
  };

  return (
    <Modal
      open={open}
      onCancel={handleCancel}
      width={500}
      centered
      closable
      footer={null} // custom footer
    >
      {/* Header */}
      <div style={{ textAlign: "center", marginBottom: 24 }}>
        <Title level={4} style={{ margin: 0 }}>
          Select Audit Type
        </Title>
      </div>
      <div className="px-2">
        {/* Body */}
        <AppSelect
          label=""
          name="auditType"
          value={auditType}
          onChange={handleChange}
          options={auditTypeOptions}
          placeholder="Choose an audit type"
          allowClear={false}
          rules={[]}
          className="w-100"
        />
      </div>

      {/* Footer */}
      <div
        style={{
          display: "flex",
          gap: "8px",
          padding: "10px",
          marginTop: "20px",
        }}
      >
        <Button
          onClick={() => handleBack("back")}
          style={{
            flex: 1,
            background: "#F5F5F5",
            color: "#6B6B6B",
            border: "1px solid #EDEDED",
            paddingTop: "24px",
            paddingBottom: "24px",
            fontSize: "18px",
            borderRadius: "8px",
          }}
        >
          Cancel
        </Button>
        <Button
          onClick={handleBack}
          style={{
            flex: 1,
            background: "#052659",
            color: "#FFFFFF",
            border: "none",
            paddingTop: "24px",
            paddingBottom: "24px",
            fontSize: "18px",
            borderRadius: "8px",
          }}
        >
          Continue
        </Button>
      </div>
    </Modal>
    // <Modal
    //   open={open}
    //   onCancel={handleCancel}
    //   footer={
    //     <div
    //       style={{
    //         display: "flex",
    //         gap: "8px",
    //         padding: "10px",
    //       }}
    //     >
    //       <Button
    //         onClick={() => handleBack("back")}
    //         style={{
    //           flex: 1,
    //           background: "#F5F5F5",
    //           color: "#6B6B6B",
    //           border: "1px solid #EDEDED",
    //           paddingTop: "24px",
    //           paddingBottom: "24px",
    //           fontSize: "18px",
    //           borderRadius: "8px",
    //         }}
    //       >
    //         Cancel
    //       </Button>
    //       <Button
    //         onClick={handleBack}
    //         style={{
    //           flex: 1,
    //           background: "#052659",
    //           color: "#FFFFFF",
    //           border: "none",
    //           paddingTop: "24px",
    //           paddingBottom: "24px",
    //           fontSize: "18px",
    //           borderRadius: "8px",
    //         }}
    //       >
    //         continue
    //       </Button>
    //     </div>
    //   }
    //   width={500}
    //   closable={true}
    //   title={
    //     <div className="d-flex flex-column align-items-center text-center">
    //       {/* Header */}
    //       <div style={{ textAlign: "left", marginBottom: 24 }}>
    //         <Title level={4} style={{ margin: 0 }}>
    //           Select Audit Type
    //         </Title>
    //       </div>

    //       {/* Body */}
    //       <AppSelect
    //         label=""
    //         name="auditType"
    //         value={auditType}
    //         onChange={handleChange}
    //         options={auditTypeOptions}
    //         placeholder="Choose an audit type"
    //         allowClear={false}
    //         rules={[]}
    //       />
    //     </div>
    //   }
    // />
  );
};

export default AuditType;
